export default {"src":"/_next/static/media/en-icon.0023e136.svg","height":23,"width":30};